
import React from 'react';
import { CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { MessageSquare, Plus } from "lucide-react";

interface TimelineHeaderProps {
  onAddInteraction: () => void;
}

export const TimelineHeader: React.FC<TimelineHeaderProps> = ({ onAddInteraction }) => (
  <div className="flex items-center justify-between">
    <CardTitle className="flex items-center gap-2">
      <MessageSquare className="h-5 w-5" />
      Communication Timeline
    </CardTitle>
    <Button size="sm" onClick={onAddInteraction}>
      <Plus className="mr-2 h-4 w-4" />
      Add Interaction
    </Button>
  </div>
);
